var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7605 3.26885C22.0532 5.05534 23.5252 7.6429 23.9042 10.5549C24.2841 13.4669 23.5259 16.3556 21.7706 18.6879C20.0145 21.0203 17.4709 22.5169 14.6085 22.9034C14.1273 22.9686 13.6469 23 13.1721 23C8.521 23.0008 4.32896 19.9576 2.88703 15.3484L4.01873 14.9821C5.43296 19.5027 9.81732 22.3237 14.4525 21.707C17.0001 21.3624 19.265 20.03 20.8281 17.9529C22.3911 15.8766 23.0654 13.3059 22.7282 10.7135C22.0294 5.36128 17.1813 1.59104 11.9216 2.29469C7.77867 2.85423 4.47853 6.08183 3.72829 10.2232L6.20062 10.257L3.05797 13.3671L0 10.1709L2.52694 10.2063C3.29697 5.45789 7.04504 1.73435 11.7657 1.09832C14.629 0.709466 17.4678 1.48235 19.7605 3.26885ZM11.9378 12.4587V5.83443H13.1249V11.7647L16.6086 13.8322L16.0103 14.8748L11.9378 12.4587Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.609b08f5a4d45f7b1ff34856e03fe3249ae5c0d02b9c2d10e9dd3947a3779dce.svg";
export { ForwardRef as ReactComponent };